var linkTargetData = ['_self', '_blank'];
export default linkTargetData;